import { PartnerScenarioTypes } from '@savgroup-front-common/types';

import partnerScenarioTypeMessages from '../helpers/i18n/messages/partnerScenarioTypeMessages';

import { safeFormattedIntlString } from './safeFormattedIntlString';

const getPartnerScenarioTypeMessage = (
  partnerScenarioType: PartnerScenarioTypes,
): ReturnType<typeof safeFormattedIntlString> => {
  let message;

  switch (partnerScenarioType?.toUpperCase()) {
    case PartnerScenarioTypes.AUTO.toUpperCase(): {
      message = partnerScenarioTypeMessages.Auto;
      break;
    }
    case PartnerScenarioTypes.MAIL.toUpperCase(): {
      message = partnerScenarioTypeMessages.Mail;
      break;
    }
    case PartnerScenarioTypes.MANUAL.toUpperCase(): {
      message = partnerScenarioTypeMessages.Manual;
      break;
    }
    case PartnerScenarioTypes.WEBPORTAL.toUpperCase(): {
      message = partnerScenarioTypeMessages.WebPortal;
      break;
    }
    case PartnerScenarioTypes.REVERS.toUpperCase(): {
      message = partnerScenarioTypeMessages.Revers;
      break;
    }
    case PartnerScenarioTypes.NONE.toUpperCase(): {
      message = partnerScenarioTypeMessages.None;
      break;
    }

    default: {
      throw new Error('Partner scenario type does not exist');
      break;
    }
  }

  return safeFormattedIntlString(message);
};

export default getPartnerScenarioTypeMessage;
